import axios from 'axios';
import * as Constants from '../utils/constants';
import { fieldService } from './fieldServices';
import { getLocalStorage } from '../utils/localStorageUtils';

const instance = axios.create({
  baseURL: Constants.ENVIRONMENT === "pord" ? process.env.PROD_BASE_URL:process.env.LOCAL_BASE_URL, 
  headers: {
    'Authorization': `Bearer ${process.env.TOKEN}`,
    'Content-Type': 'application/json', 
  },
});

export const apiClient = axios.create({
  baseURL: 'https://services.sentinel-hub.com/api', // Sentinel Hub base API URL
  headers: { 'Content-Type': 'application/json' },
});

export const instance1 = axios.create({
  baseURL: 'https://services.sentinel-hub.com/api/', 
  headers: {
    'Authorization': `Bearer ${process.env.SENTINEL_TOKEN}`,
    'Content-Type': 'application/json', 
  },
});

export const thingsBoardClient = axios.create({
  baseURL: process.env.THINGSBOARD_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  async (config) => {
    const token = await fieldService.getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const instance2 = axios.create({
  baseURL:  Constants.ENVIRONMENT === "pord" ? process.env.PROD_BASE_URL:process.env.LOCAL_BASE_URL,
});

instance2.interceptors.request.use(function (config) {
  let token: any = getLocalStorage("AuthData");
  if(token){
    config.headers["Authorization"] = "Bearer " + token.Token;
  }
  
  return config;
});

export const errorHandler = (error: any) => {
    if (error.response) {
        return error.response.data
    } else if (error.message) {
        return
    } else {
        return { errorMessage: "Something went wrong" }
    }
}

export default instance;
  